import {
    chakraComponents, ChakraStylesConfig, Props, Select
} from 'chakra-react-select';
import { ChevronDownIcon } from '../icons';

interface ExtendedProps extends Props {
	colorMode: string | undefined;
}

function AutoComplete(props: ExtendedProps) {

    const chakraStyles: ChakraStylesConfig = {
        container: (provided) => ({
            ...provided,
            cursor: 'pointer',
            textAlign: 'left',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: props.colorMode == 'light' ? 'navy' : 'white',
            textAlign: 'left'
        }),
    };

    return (
        <Select
            components={{
                DropdownIndicator: (props) => (
                    <chakraComponents.DropdownIndicator {...props}>
                        <ChevronDownIcon />
                    </chakraComponents.DropdownIndicator>
                ),
            }}
            chakraStyles={chakraStyles}
            {...props}
        />
    );
}

export default AutoComplete;
